import { Injectable } from "@angular/core";
import { ContactsDataService } from "@core-data-services/contacts.data-service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class InitiativesDataResolver  
{
  constructor(private service: ContactsDataService) { }

  public resolve(): Observable<any> | Promise<any> | any
  {
    return this.service.getList();
  }
}
